import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Logo, LogoMark } from "@/components/lunelle/Logo";
import { InviteCard } from "@/components/lunelle/InviteCard";
import { getSpot } from "@/lib/api";
import { usePageMeta } from "@/lib/usePageMeta";

export default function SpotPage() {
  usePageMeta("Your spot on the waitlist | Lunelle", "See your place on the Lunelle waitlist and share your invite link to move up the line.");
  const [params] = useSearchParams();
  const token = params.get("token");
  const [spot, setSpot] = useState(null);
  const [state, setState] = useState(token ? "loading" : "missing");

  useEffect(() => {
    if (!token) return undefined;
    getSpot(token)
      .then((d) => { setSpot(d); setState("ready"); })
      .catch(() => setState("missing"));
    return undefined;
  }, [token]);

  return (
    <div className="flex min-h-screen flex-col" data-testid="spot-page">
      <header className="mx-auto w-full max-w-7xl px-5 py-6 sm:px-8 lg:px-12"><Link to="/" data-testid="spot-home-link"><Logo /></Link></header>
      <main className="mx-auto flex w-full max-w-xl flex-1 flex-col justify-center px-5 pb-24">
        {state === "loading" && <p className="text-[#6B5A52]">Finding your spot…</p>}
        {state === "missing" && (
          <>
            <h1 className="font-serif text-5xl font-light text-[#2C221E]">Link not recognised.</h1>
            <p className="mt-5 text-lg text-[#5C4A42]">Open the link from your welcome email to see your spot.</p>
          </>
        )}
        {state === "ready" && (
          <>
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#9E4429]"><LogoMark className="h-9 w-9" color="#FBF5EE" /></span>
            <p className="mt-8 text-xs font-semibold uppercase tracking-[0.25em] text-[#9E4429]">Founding member</p>
            <h1 className="mt-3 font-serif text-6xl font-light text-[#2C221E] sm:text-7xl" data-testid="spot-position">You're #{(spot?.position ?? 0).toLocaleString()}</h1>
            {spot?.joined_position > spot?.position && (
              <p className="mt-3 text-sm text-[#6B5A52]" data-testid="spot-moved-up">You joined at #{spot.joined_position.toLocaleString()} and moved up {spot.joined_position - spot.position} spots.</p>
            )}
            <div className="mt-8 w-full">
              <InviteCard code={spot?.referral_code} referrals={spot?.referrals ?? 0} pending={spot?.pending_referrals ?? 0} spots={spot?.spots_per_friend ?? 5} prefix="spot" />
            </div>
            {spot?.confirmed === false && (
              <p className="mt-4 text-sm text-[#6B5A52]" data-testid="spot-unconfirmed-note">Your email isn't confirmed yet — tap “Confirm my email” in your welcome email.</p>
            )}
          </>
        )}
      </main>
    </div>
  );
}
